import(/* webpackMode: "eager", webpackExports: ["MillsPublicCompetitions"] */ "/Users/Apple/.codex/worktrees/allinews-mills-production-consumer/Alli-news-blog/components/mills/MillsPublicCompetitions.tsx");
